import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";
import swal from "sweetalert2";
import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import { formatUnitsForReport } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";
import showNotification from "../../../../helpers/show_notification";
import preloader from "../../../../helpers/preloader";

const TransferInventory = (props) => {
  const { SearchBar } = Search;
  useEffect(() => {
    loadTransfers();
  }, []);

  const [allTransfers, setAllTransfers] = useState([]);
  const [allTransfersFiltered, setAllTransfersFiltered] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const loadTransfers = async () => {
    let url =
      process.env.REACT_APP_BASEURL + "itemtransferorders/get_for_branch";
    const response = await postSubmitForm(url, {});
    if (response && response.status === 1) {
      setAllTransfers(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };
  useEffect(() => {
    if (selectedStatus) {
      if (selectedStatus === "All") {
        setAllTransfersFiltered(allTransfers);
      } else {
        var data = JSON.parse(JSON.stringify(allTransfers));
        setAllTransfersFiltered(
          data.filter((transfer) => transfer.status === selectedStatus)
        );
      }
    }
  }, [allTransfers, selectedStatus]);

  const [detailsModal, setDetailsModal] = useState();
  const [selectedTransfer, setSelectedTransfer] = useState();
  const [selectedTransfer_Items, setSelectedTransfer_Items] = useState([]);
  const [confirmReceive, setConfirmReceive] = useState(false);
  const [confirmRelease, setConfirmRelease] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false)
  function editFormatter(cell, row) {
    if (row.action === "release") {
      if (row.status === "Placed") {
        return (
          <button
            class="btn btn-info btn-sm mr-2"
            disabled={isDisabled}
            onClick={() => {
              setConfirmRelease(true);
              setSelectedTransfer(row);
            }}
          >
            {props.t("Release")}
          </button>
        );
      } else {
        return <span>No Action Required</span>;
      }
    } else {
      if (row.status === "Released") {
        return (
          <button
            class="btn btn-info btn-sm mr-2"
            disabled={isDisabled}
            onClick={() => {
              setConfirmReceive(true);
              setSelectedTransfer(row);
            }}
          >
            {props.t("Receive")}
          </button>
        );
      } else {
        return <span>No Action Required</span>;
      }
    }
  }
  const columns = [
    {
      dataField: "_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      csvExport: false,
    },
    {
      dataField: "order_id",
      text: props.t("Transfer ID"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Branch Name"),
      dataField: "name",
      formatter: (cell, row) => {
        if (row.action === "release") {
          return row.branch_to.name;
        } else {
          return row.branch_from.name;
        }
      },
      csvFormatter: (cell, row) => {
        if (row.action === "release") {
          return row.branch_to.name;
        } else {
          return row.branch_from.name;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },

    {
      dataField: "createdAt",
      text: props.t("Date"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "status",
      text: props.t("Status"),
      formatter: (cell, row) => {
        if (row.status === "Released") {
          return (
            <span className="font-size-12 badge-soft-info badge badge-success badge-pill mr-1 mb-1">
              {row.status}
            </span>
          );
        } else if (row.status === "Received") {
          return (
            <span className="font-size-12 badge-soft-success badge badge-success badge-pill mr-1 mb-1">
              {row.status}
            </span>
          );
        } else {
          return (
            <span className="font-size-12 badge-soft-danger badge badge-success badge-pill mr-1 mb-1">
              {row.status}
            </span>
          );
        }
      },
      csvFormatter: (cell, row) => cell,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Details"),
      formatter: (cell, row) => {
        return (
          <span className="text-info">
            <i
              className="mdi mdi-text-box-search font-size-15"
              title="View Details"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setDetailsModal(!detailsModal);
                setSelectedTransfer_Items(row.item_details);
              }}
            ></i>
          </span>
        );
      },
      csvExport: false,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      text: props.t("Action"),
      formatter: editFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      csvExport: false,
    },
  ];

  const columns_items = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "3%" };
      },
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Sub-Category"),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Quantity"),
      dataField: "quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return   row.quantity?.length>0 ? formatUnitsForReport(row.quantity) : null         
        
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },

    {
      dataField: "selling_price",
      text: props.t("Selling Price"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Expiry Date"),
      sort: false,
      formatter: (cell, row) => {
         return row.expiry_date ? moment(row.expiry_date).format("DD/MM/YYYY HH:mm") : " ";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    }
  ];
  
  const handleReceiveTransfer = async () => {
    setIsDisabled(true)
    preloader(true)
    let url = process.env.REACT_APP_BASEURL + "itemtransferorders/receive";

    const response = await postSubmitForm(url, {
      itemtransferorder_id: selectedTransfer._id,
    });
    //console.log(data_to_send);
    if (response && response.status === 1) {
      preloader(false)
      setIsDisabled(false)
      loadTransfers();
      showNotification(response.message, "Success");
    } else {
      preloader(false)
      setIsDisabled(false)
      showNotification(response.message, "Error");
    }
  };
  const handleReleaseTransfer = async () => {
    setIsDisabled(true)
    preloader(true)
    let url = process.env.REACT_APP_BASEURL + "itemtransferorders/release";
    const response = await postSubmitForm(url, {
      itemtransferorder_id: selectedTransfer._id,
    });
    //console.log(data_to_send);
    if (response && response.status === 1) {
      preloader(false)
      setIsDisabled(false)
      loadTransfers();
      showNotification(response.message, "Success");
    } else {
      preloader(false)
      setIsDisabled(false)
      showNotification(response.message, "Error");
    }
  };

  const handleDownload = async () => {
    const fileName = "item_transfer_inventory";
    const exportType = "xls";

    let data_to_export = allTransfers;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          TransferID: v.order_id,
          Name: v.action === "release" ? v.branch_to.name : v.branch_from.name,
          Remarks: v.remarks,
          Date: v.createdAt,
          Status: v.status,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Item Transfer Inventory ")}
            title={props.t("Item Transfer Inventory")}
            breadcrumbItem1={props.t("Items")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Item Transfer Inventory")}
                    </CardTitle>

                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allTransfersFiltered && allTransfersFiltered}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                      exportCSV
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={5}></Col>
                            <Col lg={3} className="text-right">
                              <select
                                name="status"
                                className="form-control"
                                value={selectedStatus}
                                onChange={(e) => {
                                  setSelectedStatus(e.target.value);
                                }}
                              >
                                <option value="All">All</option>
                                <option value="Placed">Placed</option>
                                <option value="Released">Released</option>
                                <option value="Received">Received</option>
                              </select>
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                  <Modal
                    size="lg"
                    style={{
                      width: "940px",
                      maxWidth: "950px",
                    }}
                    isOpen={detailsModal}
                    toggle={() => setDetailsModal(!detailsModal)}
                  >
                    <ModalHeader toggle={() => setDetailsModal(!detailsModal)}>
                      Transfer Item Details
                    </ModalHeader>
                    <ModalBody>
                      {selectedTransfer_Items && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col lg={12}>
                                      <ToolkitProvider
                                        keyField="_id"
                                        data={
                                          selectedTransfer_Items &&
                                          selectedTransfer_Items
                                        }
                                        columns={columns_items}
                                      >
                                        {(props) => (
                                          <div>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              noDataIndication="No data to display."
                                              striped
                                              hover
                                              condensed
                                            />
                                          </div>
                                        )}
                                      </ToolkitProvider>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>

                  {confirmRelease && (
                    <SweetAlert
                      title={props.t("Are you sure?")}
                      warning
                      showCancel
                      cancelBtnText={props.t("No")}
                      confirmBtnText={props.t("Yes")}
                      confirmBtnBsStyle="success"
                      cancelBtnBsStyle="danger"
                      onConfirm={() => {
                        setConfirmRelease(false);
                        handleReleaseTransfer();
                      }}
                      onCancel={() => {
                        setConfirmRelease(false);
                      }}
                    >
                      {props.t(
                        "Once you release this transfer, it cannot be revoked."
                      )}
                    </SweetAlert>
                  )}
                  {confirmReceive && (
                    <SweetAlert
                      title={props.t("Are you sure?")}
                      warning
                      showCancel
                      cancelBtnText={props.t("No")}
                      confirmBtnText={props.t("Yes")}
                      confirmBtnBsStyle="success"
                      cancelBtnBsStyle="danger"
                      onConfirm={() => {
                        setConfirmReceive(false);
                        handleReceiveTransfer();
                      }}
                      onCancel={() => {
                        setConfirmReceive(false);
                      }}
                    >
                      {props.t(
                        "Once you receive this transfer, it cannot be revoked."
                      )}
                    </SweetAlert>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(TransferInventory))
);
